import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './Pages/HomePage';
import './App.css';
import './style/css/style.css';
import './style/css/media.css';
import CyberSecurityPage from './Pages/CyberSecurityPage';
import AnnouncementPage from './Pages/AnnouncementPage';
import { MsalProvider } from '@azure/msal-react'
import { IPublicClientApplication } from '@azure/msal-browser';

import ProvideAppContext, { useAppContext } from './AppContext';
import ErrorMessage from './ErrorMessage';
import InnerPage from './Pages/InnerPage';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useTranslation } from 'react-i18next';
import { createGlobalStyle } from 'styled-components';


import NewsPage from "./Pages/news-page";
import NewsListPage from "./Pages/news-page/NewsListPage";
import Gallery from "./Pages/gallery";
import SingleGallery from "./Pages/gallery/SingleGallery";
import ActivitiesPage from './Pages/ActivitiesPage';
import InitiativesPage from './Pages/InitiativesPage';
import MagazinesPage from './Pages/MagazinesPage';
import VacanciesPage from './Pages/VacanciesPage';
import FaqsPage from './Pages/FaqsPage';
import Calendar from './Components/Calendar/Calendar';
import DivisionsPage from './Pages/DivisionsPage';
import PolicyPage from './Pages/PolicyPage';
import StructurePage from './Pages/StructurePage';
const queryClient = new QueryClient();

// <AppPropsSnippet>
type AppProps= {
  pca: IPublicClientApplication
};
// </AppPropsSnippet>

export default function App({ pca }: AppProps) {
  // <ReturnSnippet>
  const { t, i18n } = useTranslation();

  const GlobalStyle = createGlobalStyle`
  body {
    direction: ${i18n.language === "en" ? "ltr" : "rtl"} ;   
    text-align: ${i18n.language === "en" ? "left" : "right"} ;   
  }
`;
  const app = useAppContext();

  return(
    <MsalProvider instance={pca}>
      <ProvideAppContext>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <Routes>
            <Route path="/cyber-security" element={<CyberSecurityPage />} />
            <Route path="/Announcement" element={<AnnouncementPage />} />
            <Route path="/Structure" element={<StructurePage />} />
              <Route path="/Activities" element={<ActivitiesPage />} />
              <Route path="/Initiatives" element={<InitiativesPage />} />
              <Route path="/Magazines" element={<MagazinesPage />} />
              <Route path="/Vacancies" element={<VacanciesPage />} />
              <Route path="/" element={<HomePage />} />
              <Route path="/pages/:id" element={<InnerPage />} />
              <Route path="/Divisions/:id" element={<DivisionsPage />} />
              <Route path="/Policy/:id" element={<PolicyPage />} />
              <Route path="/gallery/:id" element={<SingleGallery />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/news" element={<NewsListPage />} />
              <Route path="/news-list/:id" element={<NewsPage />} />
              <Route path="/faq-list/:id/:category" element={<FaqsPage />} />
              <Route path="/Calendar" element={<Calendar />} />
            </Routes>
          </BrowserRouter>
        </QueryClientProvider>

      </ProvideAppContext>

      <ErrorMessage app={app} />

    </MsalProvider>
  );
  // </ReturnSnippet>
}
